import logger from "./logger";

// Format currency for display
export const formatCurrency = (value) => {
  if (value === null || value === undefined || isNaN(value)) return "N/A";
  try {
    return `$${parseFloat(value).toFixed(4)}`;
  } catch (err) {
    logger.error(`Error formatting currency value: ${value}`, err);
    return "N/A";
  }
};

// Format currency for display if value is valid
export const formatCurrencyIfValue = (value) => {
  if (value === null || value === undefined || isNaN(value)) return "";
  try {
    return `$${parseFloat(value).toFixed(4)}`;
  } catch (err) {
    logger.error(`Error formatting currency value: ${value}`, err);
    return "";
  }
};

export const formatNegativeValue = (value) => {
  if (!value) return "N/A";

  if (value < 0) {
    return (
      <span style={{ color: "red" }}>({formatCurrency(Math.abs(value))})</span>
    );
  }

  return <span>{formatCurrency(value)}</span>;
};
